// Animal categories with their types and breeds
export const animalCategories = [
  {
    category: 'Mammals',
    types: [
      { 
        name: 'Cattle', 
        breeds: ['Holstein', 'Jersey', 'Angus', 'Hereford', 'Brahman', 'Charolais', 'Simmental', 'Limousin', 'Gelbvieh', 'Ayrshire', 'Boran', 'Sahiwal', 'Friesian', 'Mixed'] 
      },
      { 
        name: 'Sheep', 
        breeds: ['Merino', 'Suffolk', 'Dorper', 'Blackhead Persian', 'Romney', 'Corriedale', 'Hampshire', 'Texel', 'Dorset', 'Mixed'] 
      },
      { 
        name: 'Goats', 
        breeds: ['Boer', 'Alpine', 'Saanen', 'Nubian', 'Toggenburg', 'Angora', 'Kalahari Red', 'Spanish', 'Galla', 'Mixed'] 
      },
      { 
        name: 'Pigs', 
        breeds: ['Duroc', 'Yorkshire', 'Hampshire', 'Berkshire', 'Landrace', 'Poland China', 'Pietrain', 'Large White', 'Meishan', 'Mixed'] 
      },
      { 
        name: 'Horses', 
        breeds: ['Arabian', 'Thoroughbred', 'Quarter Horse', 'Appaloosa', 'Morgan', 'Andalusian', 'Friesian', 'Clydesdale', 'Shire', 'Mixed'] 
      },
      { 
        name: 'Rabbits', 
        breeds: ['New Zealand White', 'Californian', 'Rex', 'Flemish Giant', 'Dutch', 'Angora', 'Mini Lop', 'Netherland Dwarf', 'Mixed'] 
      },
      { 
        name: 'Camelids', 
        breeds: ['Alpaca', 'Llama', 'Dromedary Camel', 'Bactrian Camel', 'Vicuña', 'Guanaco', 'Mixed'] 
      },
      {
        name: 'Other Mammals',
        breeds: ['Custom Breed'] 
      }
    ]
  },
  {
    category: 'Birds',
    types: [
      { 
        name: 'Chickens', 
        breeds: ['Layers', 'Broilers', 'Rhode Island Red', 'Plymouth Rock', 'Leghorn', 'Sussex', 'Orpington', 'Australorp', 'Wyandotte', 'Brahma', 'Indigenous', 'Mixed'] 
      },
      { 
        name: 'Ducks', 
        breeds: ['Pekin', 'Muscovy', 'Mallard', 'Runner', 'Rouen', 'Khaki Campbell', 'Call Duck', 'Swedish', 'Mixed'] 
      },
      { 
        name: 'Turkeys', 
        breeds: ['Broad Breasted White', 'Broad Breasted Bronze', 'Bourbon Red', 'Black Spanish', 'Narragansett', 'Royal Palm', 'Mixed'] 
      },
      { 
        name: 'Geese', 
        breeds: ['Toulouse', 'Embden', 'Chinese', 'African', 'Sebastopol', 'Pilgrim', 'American Buff', 'Mixed'] 
      },
      { 
        name: 'Quail', 
        breeds: ['Coturnix', 'Button Quail', 'Bobwhite', 'California Quail', 'Mixed'] 
      },
      { 
        name: 'Guinea Fowl', 
        breeds: ['Helmeted', 'Vulturine', 'Crested', 'Plumed', 'Mixed'] 
      },
      { 
        name: 'Pigeons', 
        breeds: ['Racing Homer', 'King', 'Fantail', 'Tumbler', 'Carneau', 'Mixed'] 
      },
      { 
        name: 'Ostriches', 
        breeds: ['African Black', 'Blue Neck', 'Red Neck', 'Mixed'] 
      },
      {
        name: 'Other Birds',
        breeds: ['Custom Breed'] 
      }
    ]
  },
  {
    category: 'Reptiles',
    types: [
      { 
        name: 'Snakes', 
        breeds: ['Ball Python', 'Corn Snake', 'Boa Constrictor', 'Reticulated Python', 'King Snake', 'Custom'] 
      },
      { 
        name: 'Lizards', 
        breeds: ['Bearded Dragon', 'Gecko', 'Iguana', 'Monitor', 'Chameleon', 'Custom'] 
      },
      { 
        name: 'Turtles', 
        breeds: ['Red-Eared Slider', 'Box Turtle', 'Sulcata Tortoise', 'Leopard Tortoise', 'Custom'] 
      },
      { 
        name: 'Crocodilians', 
        breeds: ['American Alligator', 'Nile Crocodile', 'Spectacled Caiman', 'Custom'] 
      },
      {
        name: 'Other Reptiles',
        breeds: ['Custom Breed'] 
      }
    ]
  },
  {
    category: 'Aquatic',
    types: [
      { 
        name: 'Fish', 
        breeds: ['Tilapia', 'Catfish', 'Carp', 'Trout', 'Salmon', 'Bass', 'Ornamental', 'Custom'] 
      },
      { 
        name: 'Crustaceans', 
        breeds: ['Prawns', 'Crayfish', 'Crabs', 'Lobsters', 'Custom'] 
      },
      {
        name: 'Other Aquatic',
        breeds: ['Custom Breed'] 
      }
    ]
  },
  {
    category: 'Insects',
    types: [
      { 
        name: 'Bees', 
        breeds: ['Italian', 'Carniolan', 'Caucasian', 'Buckfast', 'Russian', 'Custom'] 
      },
      { 
        name: 'Silkworms', 
        breeds: ['Bombyx mori', 'Wild Silkworms', 'Custom'] 
      },
      { 
        name: 'Crickets', 
        breeds: ['House Cricket', 'Field Cricket', 'Custom'] 
      },
      {
        name: 'Other Insects',
        breeds: ['Custom Breed'] 
      }
    ]
  },
  {
    category: 'Genetically Modified',
    types: [
      { 
        name: 'Hybrid Animals', 
        breeds: ['Custom Breed'] 
      },
      { 
        name: 'Gene-Edited', 
        breeds: ['CRISPR Modified', 'Transgenic', 'Custom'] 
      }
    ]
  }
];

// Flattened animal types list for backward compatibility
export const animalTypes = animalCategories.flatMap(category => 
  category.types.map(type => type.name)
);

// Combined animal statuses
export const animalStatuses = [
  'healthy',
  'sick',
  'treatment',
  'quarantined',
  'pregnant',
  'recovering',
  'lactating', 
  'growing', 
  'mature', 
  'culled', 
  'sold', 
  'deceased'
];

export const animalPurposes = [
  'dairy',
  'meat',
  'dual',
  'breeding',
  'other',
];

export const ageUnits = [
  'days',
  'months',
  'years',
  'weeks'
];

export const medicalRecordTypes = [
  'routine',
  'treatment',
  'vaccination', 
  'surgery',
  'birth',
  'other'
];

// Animal types and breeds mapping (for quick lookup)
export const animalTypeBreeds: Record<string, string[]> = {
  'Cattle': ['Angus', 'Holstein', 'Jersey', 'Hereford', 'Charolais', 'Simmental', 'Limousin', 'Brahman', 'Gelbvieh', 'Shorthorn', 'Ayrshire', 'Guernsey', 'Red Angus', 'Texas Longhorn', 'Highland', 'Dexter', 'Friesian', 'Belgian Blue', 'Zebu', 'Beefmaster'],
  'Goat': ['Boer', 'Alpine', 'Saanen', 'Nubian', 'LaMancha', 'Oberhasli', 'Toggenburg', 'Nigerian Dwarf', 'Pygmy', 'Kiko', 'Spanish', 'Myotonic', 'Kinder', 'Savanna', 'Cashmere', 'Sable', 'Golden Guernsey', 'Angora', 'Beetal', 'Damascus'],
  'Sheep': ['Merino', 'Suffolk', 'Dorper', 'Hampshire', 'Dorset', 'Blackface', 'Texel', 'Corriedale', 'Romney', 'Columbia', 'Rambouillet', 'Southdown', 'Leicester', 'Jacob', 'Cheviot', 'Finnsheep', 'Karakul', 'Katahdin', 'Awassi', 'East Friesian'],
  'Pig': ['Yorkshire', 'Duroc', 'Hampshire', 'Berkshire', 'Landrace', 'Chester White', 'Spotted', 'Poland China', 'Tamworth', 'Hereford', 'Large Black', 'Mulefoot', 'Red Wattle', 'American Guinea Hog', 'Gloucestershire Old Spot', 'Kunekune', 'Mangalitsa', 'Pietrain', 'Lacombe', 'Meishan'],
  'Poultry': ['Leghorn', 'Rhode Island Red', 'Plymouth Rock', 'Orpington', 'Wyandotte', 'Sussex', 'Brahma', 'Australorp', 'Silkie', 'Cochin', 'Ameraucana', 'Marans', 'Minorca', 'Polish', 'Faverolles', 'Langshan', 'Hamburg', 'Cornish', 'Dominique', 'Jersey Giant'],
  'Horse': ['Arabian', 'Thoroughbred', 'Quarter Horse', 'Appaloosa', 'Morgan', 'Clydesdale', 'Percheron', 'Friesian', 'Andalusian', 'Paint', 'Standardbred', 'Tennessee Walker', 'Lipizzaner', 'Belgian', 'Hackney', 'Shetland Pony', 'Mustang', 'Haflinger', 'Fjord', 'Trakehner'],
  'Rabbit': ['New Zealand White', 'Californian', 'Rex', 'Flemish Giant', 'Dutch', 'Mini Lop', 'Holland Lop', 'French Lop', 'Angora', 'Chinchilla', 'English Spot', 'Netherland Dwarf', 'Polish', 'Harlequin', 'Belgian Hare', 'American', 'Britannia Petite', 'Himalayan', 'Silver Fox', 'Champagne D\'Argent'],
  'Camelid': ['Alpaca', 'Llama', 'Dromedary Camel', 'Bactrian Camel', 'Vicuña', 'Guanaco'],
  'Fish': ['Tilapia', 'Catfish', 'Carp', 'Trout', 'Salmon', 'Bass', 'Perch', 'Sturgeon', 'Pangasius', 'Barramundi', 'Koi', 'Goldfish', 'Clownfish', 'Guppies', 'Angelfish', 'Zebrafish', 'Discus', 'Betta', 'Cichlids', 'Tetra'],
  'Other Bird': ['Turkey', 'Duck', 'Goose', 'Pheasant', 'Quail', 'Guinea Fowl', 'Peacock', 'Emu', 'Ostrich', 'Swan', 'Dove', 'Pigeon', 'Partridge', 'Canary', 'Finch', 'Budgerigar', 'Cockatiel', 'Parrot', 'Falcon', 'Hawk'],
  'Reptile': ['Turtle', 'Tortoise', 'Snake', 'Lizard', 'Crocodile', 'Alligator', 'Iguana', 'Gecko', 'Chameleon', 'Bearded Dragon', 'Monitor Lizard', 'Python', 'Boa', 'Anaconda', 'Cobra', 'Viper', 'Skink', 'Anole', 'Tegu', 'Uromastyx'],
  'Amphibian': ['Frog', 'Toad', 'Salamander', 'Newt', 'Axolotl', 'Caecilian'],
  'Invertebrate': ['Bee', 'Butterfly', 'Cricket', 'Grasshopper', 'Earthworm', 'Snail', 'Crayfish', 'Prawn', 'Shrimp', 'Lobster', 'Crab', 'Scorpion', 'Tarantula', 'Millipede', 'Centipede', 'Beetle', 'Ant', 'Silkworm', 'Ladybug', 'Cockroach'],
  'Exotic': ['Zebra', 'Giraffe', 'Elephant', 'Rhinoceros', 'Lion', 'Tiger', 'Cheetah', 'Leopard', 'Bear', 'Wolf', 'Kangaroo', 'Wallaby', 'Koala', 'Panda', 'Sloth', 'Chimpanzee', 'Gorilla', 'Lemur', 'Meerkat', 'Fox'],
  'Laboratory': ['Mouse', 'Rat', 'Guinea Pig', 'Hamster', 'Ferret', 'Gerbil', 'Chinchilla', 'Monkey', 'Fruit Fly', 'Zebrafish'],
  'GMO': ['GMO Goat', 'GMO Cow', 'GMO Pig', 'GMO Fish', 'GMO Chicken', 'Lab-Grown Meat', 'Transgenic Animal']
};
